const trackingPdp = {
    data: undefined,
    htmlDecode(value) {
        return $('<textarea/>').html(value).text();
    },
    readTrackingData(element) {
        // https://mathiasbynens.be/notes/json-dom-csp
        // for decoding: (maybe use of https://www.npmjs.com/package/he)
        // https://stackoverflow.com/questions/7394748/whats-the-right-way-to-decode-a-string-that-has-special-html-entities-in-it
        // Read the JSON-formatted data from the DOM.
        this.data         = JSON.parse(this.htmlDecode(element.textContent));
        // Clear the element’s contents now that we have a copy of the data.
        element.innerHTML = '';
    },
    trackProductDetailView() {
        dataLayer.push({
            'event':     'EECproductDetail',
            'ecommerce': {
                'detail': {
                    'products': [
                        {
                            'name':     this.data.name,
                            'id':       this.data.baseId,
                            'item_variant': this.data.id,
                            'item_color': this.data.color,
                            'item_size': this.data.size,
                            'price':    this.data.price !== undefined ? this.data.price.toString() : undefined,
                            'brand':    this.data.brand,
                            'category': `${this.data.gtmGender}/${this.data.categoryName}`,
                        }]
                }
            }
        });
        dataLayer.push({
            event:     'view_item',
            ecommerce: {
                currency: this.data.currencyCode,
                items:    [
                    {
                        'item_name':      this.data.name,
                        'item_id':        this.data.baseId,
                        'item_variant':   this.data.id,
                        'item_color':     this.data.color,
                        'item_size':      this.data.size,
                        'price':          this.data.price !== undefined ? this.data.price.toString() : undefined,
                        'item_brand':     this.data.brand,
                        'item_category':  `${this.data.gtmGender}/${this.data.categoryName}`,
                        'item_category2': this.data.category2 ? this.data.category2 : "",
                        'item_list_name': 'productDetail',
                        'item_list_id':   'pdp',
                        'index':          1,
                        'quantity':       1
                    }]
            }
        });
    },
};

export default trackingPdp;
